export default __webpack_public_path__ + "static/customer-success-partnership-be971db9b677cd404664932c17f1db76.webp";